<template>
  <dl class="mb-8">
    <DescriptionListItem>
      <template #title>
        <span class="capitalize">{{ $t('model') }}</span>
      </template>
      <template #default>
        {{ selectedCar?.make }} {{ selectedCar?.model }}
      </template>
    </DescriptionListItem>
    <DescriptionListItem v-if="selectedCar?.color?.name">
      <template #title>
        Color
      </template>
      <template #default>
        <div class="flex items-center gap-x-2">
          <span class="w-4 h-4 block rounded-full border border-white" :style="{ backgroundColor: selectedCar?.color?.hex }" />  <span class="capitalize">{{ selectedCar?.color?.name }}</span>
        </div>
      </template>
    </DescriptionListItem>
    <DescriptionListItem v-if="!hideVehicleCatalogFilters">
      <template #title>
        <span class="capitalize">{{ $t('zone') }}</span>
      </template>
      <template #default>
        {{ selectedBooking?.station?.name }}
      </template>
    </DescriptionListItem>
    <DescriptionListItem>
      <template #title>
        <span class="capitalize">{{ $t('date', 2) }}</span>
      </template>
      <template #default>
        {{ getDateFormat(selectedBooking?.start as string) }} - {{ selectedBooking?.monthsLong }} {{ $t('month', cartStore.selectedBooking.monthsLong) }}
      </template>
    </DescriptionListItem>    <DescriptionListItem>
      <template #title>
        <span class="capitalize">{{ $t('kilometers') }}</span>
      </template>
      <template #default>
        {{ selectedBooking?.km }}km
      </template>
    </DescriptionListItem>

    <!-- TODO wait until BE develop the new format price on WWM-1463
    <DescriptionListItem>
      <template #title>
        <span class="first-letter:uppercase">{{ $t('first_f') }} {{ $t('installment') }}</span>
      </template>
      <template #default>
        {{ computedTotal }} €/{{ $t('month') }}
      </template>
    </DescriptionListItem>

    <DescriptionListItem>
      <template #title>
        <span class="first-letter:uppercase">{{ $t('rest') }} {{ $t('of') }} {{ $t('installment', 2) }}</span>  Resto de cuotas
      </template>
      <template #default>
        {{ recurrentPaymentFeaturesItems?.totalAmount }} €/{{ $t('month') }}
      </template>
    </DescriptionListItem>
  -->
    <DescriptionListItem>
      <template #title>
        Total
      </template>
      <template #default>
        {{ selectedCar?.price }}
      </template>
    </DescriptionListItem>
  </dl>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import DescriptionListItem from '~/components/modals/DescriptionListItem.vue';
import { useCartStore } from '~/stores/cartStore';
import { dateFormat } from '~/lib/utils';
import { useFeatureHandler } from '~/composables';

const { hideVehicleCatalogFilters } = useFeatureHandler();
const cartStore = useCartStore();
const { selectedCar, selectedBooking /* recurrentPaymentFeaturesItems , computedTotal */ } = storeToRefs(cartStore);

function getDateFormat (dateStr: string) {
  return dateFormat(new Date(dateStr || ''), {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
}
</script>
